import { portalJson } from '../lib/portalApi';

export type AdminResourceCategory = 'notice' | 'law' | 'docs' | 'news';

export type AdminResourcePost = {
  id: number;
  category: string;
  title: string;
  summary: string;
  body: string;
  source_label: string;
  source_url: string;
  attachment_label: string;
  attachment_url: string;
  is_published: boolean;
  is_pinned: boolean;
  sort_order: number;
  created_at?: string | null;
  updated_at?: string | null;
  published_at?: string | null;
};

export type AdminResourcePostInput = {
  category: AdminResourceCategory;
  title: string;
  summary: string;
  body: string;
  source_label: string;
  source_url: string;
  attachment_label: string;
  attachment_url: string;
  is_published: boolean;
  is_pinned: boolean;
  sort_order: number;
};

const BASE = '/api/admin/ev123/resources';

function listUrl(params: { category?: string; q?: string }): string {
  const sp = new URLSearchParams();
  if (params.category && params.category !== 'all') sp.set('category', params.category);
  if (params.q?.trim()) sp.set('q', params.q.trim());
  const qs = sp.toString();
  return qs ? `${BASE}?${qs}` : BASE;
}

export async function listAdminResources(params: { category?: string; q?: string }) {
  const r = await portalJson<AdminResourcePost[]>(listUrl(params), { auth: true });
  if (!r.ok) return r;
  return { ok: true as const, data: Array.isArray(r.data) ? r.data : [] };
}

export async function createAdminResource(body: AdminResourcePostInput) {
  return portalJson<AdminResourcePost>(BASE, {
    method: 'POST',
    auth: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function updateAdminResource(id: number, body: AdminResourcePostInput) {
  return portalJson<AdminResourcePost>(`${BASE}/${id}`, {
    method: 'PUT',
    auth: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function deleteAdminResource(id: number) {
  return portalJson<unknown>(`${BASE}/${id}`, { method: 'DELETE', auth: true });
}

export async function patchAdminResourcePublish(id: number, is_published: boolean) {
  return portalJson<AdminResourcePost>(`${BASE}/${id}/publish`, {
    method: 'PATCH',
    auth: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ is_published }),
  });
}

export async function patchAdminResourcePin(id: number, is_pinned: boolean) {
  return portalJson<AdminResourcePost>(`${BASE}/${id}/pin`, {
    method: 'PATCH',
    auth: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ is_pinned }),
  });
}
